module.exports = __webpack_public_path__ + "img/TALHADEIRA CURVA PONTA PLANA  -mobile.b0b77459.png";